import { render, staticRenderFns } from "./MypageOrdersViewPage.vue?vue&type=template&id=59027e10&"
import script from "./MypageOrdersViewPage.vue?vue&type=script&lang=js&"
export * from "./MypageOrdersViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports